import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuthStore } from '../store/authStore'

// Gate for private routes. Replaces the old imperative screen-switching logic
// in app.js (`decide which screen to show` based on the localStorage token).
export default function AuthGuard({ children }: { children: ReactNode }) {
  const accessToken = useAuthStore((s) => s.accessToken)
  const location = useLocation()

  if (!accessToken) {
    // Guests start the funnel right away at "Давайте познакомимся" — the intro
    // welcome screen is paused (design v2); /welcome itself just redirects here.
    return <Navigate to="/onboarding" replace state={{ from: location }} />
  }

  return children
}
